import ProfileMessagesIntermediationService from "@services/profile-messages-intermediation-service";
import { initialiseComponents } from "../../core";
import Component from "../component.abstract";

interface ProfileMessageCvSeenProps {
  datetimeLabel: string;
  firstImageLink: string;
  buttonLink: string;
  companyName: string;
  isNew: boolean;
  trackingsClick: any;
}

export default class ProfileMessageCvSeen extends Component {
  private elDate: HTMLElement;
  private elImage: HTMLElement;
  private elMessage: HTMLElement;
  private elLink: HTMLAnchorElement;

  constructor(private props: ProfileMessageCvSeenProps, element: HTMLElement) {
    super(props, element);
  }

  mounted(): void {
    this.injectTemplate();

    initialiseComponents();

    this.elDate = this.element.querySelector("[data-pm-date]");
    this.elImage = this.element.querySelector("[data-pm-image]");
    this.elMessage = this.element.querySelector("[data-pm-message]");
    this.elLink = this.element.querySelector("[data-pm-link]");

    this.setFields();
    this.setHandlers();
  }
  setFields(): void {
    this.elDate.innerText = this.props.datetimeLabel;
    let img: HTMLElement;
    if (this.props.firstImageLink) {
      const logo = new Image();
      logo.src = this.props.firstImageLink;
      img = document.createElement("div");
      img.appendChild(logo);
      img.classList.add("message-cv-seen-body-pictures-logo");
    } else {
      img = document.createElement("div");
      img.classList.add("message-cv-seen-body-pictures-anonymous");
    }
    this.elImage.appendChild(img);

    this.elMessage.innerHTML =
      "Votre CV est visible auprès de nos recruteurs. L’entreprise " +
      this.props.companyName +
      " vient de le consulter, tenez-vous prêt à être peut-être contacté&nbsp;!";

    if (this.props.buttonLink) {
      this.elLink.href = this.props.buttonLink;
    } else {
      this.elLink.remove();
    }
    

    if (this.props.isNew === true) {
      this.element.classList.add("new");
    }
 
    this.element.classList.add("loaded");
  }
  setHandlers(): void {
    this.elLink.addEventListener("click", () => {
        window.dataLayer.push(this.props.trackingsClick[0]);
    });
    this.element.querySelector(".message-cv-seen-header").addEventListener("click", (event: Event) => {
        if ((<HTMLElement>event.target).closest("svg")) {
          // TODO: Add AJAX call here
          //self.fireRemoved();
        }
    });
  }
  
}
